import { makeStyles } from '@material-ui/core/styles';

export const ImcGenericStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    borderRadius: theme.spacing(2), // Agregamos un border-radius
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)', // Agregamos sombra
    
  },
  fixedHeight: {
    height: 280, // Ajustamos la altura de las tarjetas
    
  },
  fixedHeightFilter: {
    height: 180,
  },
  fixedHeightTarg: {
    height: 320, // Ajustamos la altura de las tarjetas
    borderRadius: theme.spacing(2), // Agregamos un border-radius
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)', // Agregamos sombra
    overflow: 'hidden',
  },
  buttonProgress: {
    color: 'primary',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  [theme.breakpoints.down('xs')]: {
    fixedHeight: {
      height: 400, // Ajustamos la altura de las tarjetas
    },
    fixedHeightFilter: {
      height: 240,
    },
    fixedHeightTarg: {
      height: 360, // Ajustamos la altura de las tarjetas
      borderRadius: theme.spacing(2), // Agregamos un border-radius
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)', // Agregamos sombra
    },
    datePickerIcon: {
      fill: theme.palette.primary.main, // Establece el color primario como color de relleno (fill) para el icono del date picker
    },
    calendarIcon: {
      color: theme.palette.primary.main, // Establece el color primario como color del icono
    }
  },
}));
